import CryptoJS from 'crypto-js';

/**
 * 密码生成工具类
 * 与后端Go代码算法完全一致
 */
export class PasswordGenerator {
  /**
   * 生成12位密码
   * 算法说明：
   * 1. 输入：日期(YYYYMMDD格式) + 设备ID
   * 2. 计算MD5哈希值
   * 3. 将哈希值的前12个字符转换为62进制字符集(0-9,A-Z,a-z)
   */
  static generatePassword(date: Date, deviceId: string): string {
    // 格式化日期为 YYYYMMDD
    const dateStr = this.formatDateToYYYYMMDD(date);

    // 组合日期和设备ID
    const input = dateStr + deviceId;

    // 生成MD5哈希
    const hash = CryptoJS.MD5(input).toString();

    // 转换为12位字母数字密码
    return this.hashToPassword(hash);
  }

  /**
   * 格式化日期为 YYYYMMDD
   */
  private static formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }

  /**
   * 将MD5哈希转换为12位字母数字密码
   */
  private static hashToPassword(hash: string): string {
    // 字符集：0-9, A-Z, a-z (共62个字符)
    const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charsetLen = charset.length;

    const password: string[] = [];

    // 取哈希的前12个字符并转换为字符集索引
    for (let i = 0; i < 12; i++) {
      let byteVal = 0;
      if (i < hash.length) {
        const char = hash[i];
        if (char >= '0' && char <= '9') {
          byteVal = char.charCodeAt(0) - '0'.charCodeAt(0);
        } else if (char >= 'a' && char <= 'f') {
          byteVal = char.charCodeAt(0) - 'a'.charCodeAt(0) + 10;
        } else if (char >= 'A' && char <= 'F') {
          byteVal = char.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        }
      }

      // 映射到字符集（使用模运算确保有效索引）
      password.push(charset[byteVal % charsetLen]);
    }

    return password.join('');
  }

  /**
   * 解析日期字符串 (YYYY-MM-DD 格式)
   */
  static parseDate(dateStr: string): Date {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date format. Use YYYY-MM-DD format.');
    }
    return date;
  }
}